import filter from "lodash/filter";

interface Breakpoint {
  label: string;
  minWidth?: number;
  maxWidth?: number;
}

const breakpoints: Breakpoint[] = [
  {
    label: "xxs",
    minWidth: 0,
    maxWidth: 479
  },
  {
    label: "xs",
    minWidth: 480,
    maxWidth: 767
  },
  {
    label: "sm",
    minWidth: 768,
    maxWidth: 991
  },
  {
    label: "md",
    minWidth: 992,
    maxWidth: 1199
  },
  {
    label: "lg",
    minWidth: 1200,
    maxWidth: null
  }
];

export function Breakpoint(): string {
  const clientWidth: number = document.body.clientWidth;

  let range = filter(
    breakpoints,
    (breakpoint: Breakpoint): boolean => {
      if (breakpoint.maxWidth === null && clientWidth > breakpoint.minWidth) {
        return true;
      } else {
        return clientWidth >= breakpoint.minWidth && clientWidth < breakpoint.maxWidth;
      }
    }
  );

  return range.length ? range[0].label : null;
}
